// Mock data for the home care nurse website

export const siteConfig = {
  nurseName: "Votre Infirmière",
  phone: "+32 460 95 38 57",
  email: "douniaa-k@hotmail.be",
  address: "Fleurus, Belgique",
};

export const serviceAreas = [
  {
    id: "fleurus",
    name: "Fleurus",
    coordinates: { lat: 50.4833, lng: 4.55 },
    postalCode: "6220",
    description: "Service complet de soins infirmiers à domicile pour les résidents de Fleurus et ses environs. Interventions rapides et suivi personnalisé.",
  },
  {
    id: "sambreville",
    name: "Sambreville",
    coordinates: { lat: 50.446734, lng: 4.630735 },
    postalCode: "5060",
    description: "Soins infirmiers professionnels à domicile pour la commune de Sambreville. Service conventionné INAMI avec possibilité de tiers payant.",
  },
  {
    id: "farciennes",
    name: "Farciennes",
    coordinates: { lat: 50.4301, lng: 4.5415 },
    postalCode: "6240",
    description: "Prise en charge infirmière à domicile pour les habitants de Farciennes. Soins adaptés aux personnes âgées et patients à mobilité réduite.",
  },
];

export const nursingServices = [
  {
    id: "injections",
    title: "Injections",
    description: "Administration d'injections sous-cutanées, intramusculaires ou intraveineuses selon prescription médicale.",
    icon: "Syringe",
    details: [
      "Injections d'insuline",
      "Vaccinations",
      "Injections anticoagulantes",
      "Traitements hormonaux",
    ],
    requiresPrescription: true,
    inami: true,
  },
  {
    id: "wound-care",
    title: "Soins de plaies",
    description: "Traitement et pansements de plaies chroniques, post-opératoires ou traumatiques avec techniques adaptées.",
    icon: "Bandage",
    details: [
      "Plaies chroniques",
      "Escarres",
      "Ulcères variqueux",
      "Brûlures",
      "Plaies post-opératoires",
    ],
    requiresPrescription: true,
    inami: true,
  },
  {
    id: "personal-hygiene",
    title: "Toilette et hygiène",
    description: "Aide à la toilette complète ou partielle pour personnes à mobilité réduite, avec respect de la dignité et du confort.",
    icon: "Droplets",
    details: [
      "Toilette au lit ou au lavabo",
      "Soins d'hygiène corporelle",
      "Aide au bain",
      "Prévention des escarres",
    ],
    requiresPrescription: true,
    inami: true,
  },
  {
    id: "blood-samples",
    title: "Prises de sang",
    description: "Prélèvements sanguins à domicile selon prescription médicale, avec acheminement au laboratoire.",
    icon: "TestTube",
    details: [
      "Prélèvements sanguins",
      "Tests de glycémie",
      "Envoi au laboratoire",
      "Résultats transmis au médecin",
    ],
    requiresPrescription: true,
    inami: true,
  },
  {
    id: "medication-management",
    title: "Suivi de traitement",
    description: "Préparation et distribution des médicaments, surveillance de l'observance thérapeutique.",
    icon: "Pill",
    details: [
      "Préparation des piluliers",
      "Administration des médicaments",
      "Surveillance effets secondaires",
      "Coordination avec médecin traitant",
    ],
    requiresPrescription: true,
    inami: true,
  },
  {
    id: "elderly-care",
    title: "Soins aux personnes âgées",
    description: "Accompagnement global des personnes âgées à domicile avec approche humaine et bienveillante.",
    icon: "Heart",
    details: [
      "Surveillance état de santé",
      "Aide aux gestes quotidiens",
      "Prévention des chutes",
      "Soutien moral",
      "Coordination avec famille",
    ],
    requiresPrescription: true,
    inami: true,
  },
];

export const advantages = [
  {
    id: "home-comfort",
    title: "Confort de votre domicile",
    description: "Recevez vos soins dans le cadre rassurant de votre maison, sans déplacement.",
    icon: "Home",
  },
  {
    id: "inami-approved",
    title: "Conventionnée INAMI",
    description: "Soins remboursés par la mutuelle selon les barèmes officiels. Tiers payant possible.",
    icon: "BadgeCheck",
  },
  {
    id: "personalized",
    title: "Suivi personnalisé",
    description: "Approche humaine et écoute attentive de vos besoins spécifiques.",
    icon: "UserCheck",
  },
  {
    id: "responsive",
    title: "Réactivité",
    description: "Interventions rapides et planning adapté à vos contraintes horaires.",
    icon: "Clock",
  },
];

export const aboutInfo = {
  title: "Votre infirmière à domicile",
  introduction: "Infirmière diplômée avec plusieurs années d'expérience dans le secteur des soins à domicile, je mets mon expertise au service des patients de Fleurus, Sambreville et Farciennes.",
  education: [
    "Diplôme d'infirmière graduée - Haute École",
    "Formation continue en soins de plaies",
    "Spécialisation en gériatrie",
  ],
  values: [
    {
      title: "Professionnalisme",
      description: "Respect strict des prescriptions médicales et des protocoles de soins.",
    },
    {
      title: "Humanité",
      description: "Approche bienveillante et écoute attentive de chaque patient.",
    },
    {
      title: "Confidentialité",
      description: "Secret professionnel et respect de votre vie privée garantis.",
    },
  ],
  experience: "Plus de 10 ans d'expérience en soins infirmiers à domicile, avec une attention particulière portée aux personnes âgées et aux patients en convalescence.",
  approach: "Ma priorité est de vous offrir des soins de qualité dans le respect de votre autonomie et de votre dignité. Je travaille en étroite collaboration avec votre médecin traitant et votre famille pour assurer un suivi optimal.",
};

export const testimonials = [
  {
    id: 1,
    name: "Marie D.",
    location: "Fleurus",
    rating: 5,
    comment: "Très professionnelle et à l'écoute. Ma maman se sent en confiance pour ses soins quotidiens.",
    date: "2024-11",
  },
  {
    id: 2,
    name: "Jean P.",
    location: "Sambreville",
    rating: 5,
    comment: "Ponctuelle et compétente. Les soins de plaies sont réalisés avec beaucoup de soin.",
    date: "2024-10",
  },
  {
    id: 3,
    name: "Sophie L.",
    location: "Farciennes",
    rating: 5,
    comment: "Une infirmière en or ! Toujours disponible et d'une grande gentillesse avec mon père.",
    date: "2024-12",
  },
];

export const faqItems = [
  {
    id: "remboursement",
    question: "Les soins infirmiers sont-ils remboursés ?",
    answer: "Oui, tous les soins prescrits par un médecin sont remboursés par la mutuelle selon les barèmes INAMI. Le tiers payant est possible selon votre situation.",
  },
  {
    id: "prescription",
    question: "Ai-je besoin d'une prescription médicale ?",
    answer: "Oui, une prescription médicale est obligatoire pour tous les soins infirmiers techniques (injections, pansements, prises de sang, etc.).",
  },
  {
    id: "horaires",
    question: "Quels sont vos horaires d'intervention ?",
    answer: "J'interviens du lundi au vendredi de 8h à 18h, le samedi de 9h à 13h. Pour les urgences le dimanche, merci de me contacter par téléphone.",
  },
  {
    id: "zone",
    question: "Intervenez-vous dans toutes les communes ?",
    answer: "J'interviens principalement à Fleurus, Sambreville et Farciennes. Pour les communes limitrophes, n'hésitez pas à me contacter pour vérifier la disponibilité.",
  },
];

// Mock function to simulate form submission
export const mockContactSubmission = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Mock form submission:", formData);
      resolve({
        success: true,
        message: "Votre message a été envoyé avec succès. Je vous recontacterai dans les plus brefs délais.",
      });
    }, 1000);
  });
};
